"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidePanelPageOptions = exports.SidePanelPageTitle = exports.SidePanelPageHeader = exports.SidePanelPageBody = exports.SidePanelPage = void 0;
const React = require("react");
const Section_1 = require("../../abstract/Section");
/**
 *  Container for a side panel page
 */
const SidePanelPage = ({ children }) => (React.createElement("div", { "data-test": "side-panel-page" },
    React.createElement(Section_1.Section, { size: "lg" }, children)));
exports.SidePanelPage = SidePanelPage;
/**
 *  Main content of a side panel page
 */
const SidePanelPageBody = ({ children }) => (React.createElement(Section_1.Body, null, children));
exports.SidePanelPageBody = SidePanelPageBody;
/**
 *  Renders the side panel page header with title and optional options
 */
const SidePanelPageHeader = ({ decorationImage, className, children }) => React.createElement(Section_1.Header, { className: className }, children);
exports.SidePanelPageHeader = SidePanelPageHeader;
/**
 *  Renders the side panel page header with title and optional options
 */
const SidePanelPageTitle = ({ children }) => (React.createElement(Section_1.Title, { size: 2 }, children));
exports.SidePanelPageTitle = SidePanelPageTitle;
/**
 * Renders a side panel page options
 */
const SidePanelPageOptions = props => (React.createElement(Section_1.Options, Object.assign({}, props)));
exports.SidePanelPageOptions = SidePanelPageOptions;
//# sourceMappingURL=index.js.map